module.exports = __webpack_public_path__ + "img/youtube.023308ad.png";